import {useController, useFormContext} from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const FormSwitch = ({name: propsName, label, onChangeHandler = null}) => {
    const {control} = useFormContext();
    const {
        field: {onChange, name, value, ref},
    } = useController({
        name: propsName,
        control,
    });

    const labelStyle = {
        "&.MuiFormControlLabel-root": {
            marginLeft: 0,
            "& .MuiTypography-root": {
                color: "grey.800",
                fontSize: "14px",
                lineHeight: 1.25,
            },
        },
    };

    return (
        <FormControlLabel
            label={label}
            labelPlacement="start"
            id={`${name}-switch-label`}
            sx={labelStyle}
            control={
                <Switch
                    id={`${name}-switch`}
                    checked={value}
                    inputRef={ref}
                    onChange={event => {
                        onChange(event);
                        if (onChangeHandler) {
                            onChangeHandler(event);
                        }
                    }}
                />
            }
        />
    );
};

export default FormSwitch;
